import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { mountComparison } from '../../data/mountSystem';

/** Removable setup vs. Magnetic Mount System — fixed position, exchangeable light. */
export function PositionComparison() {
  return <div data-id="element-543" data-mp="2ubx9663s58be">
      <div className="grid gap-4 md:grid-cols-2" data-id="element-544" data-mp="2ubniegawux4n">
        <figure className="border border-white/10 bg-[#06121F] p-5" data-id="element-545" data-mp="2pdlwzoq0ilq0">
          <figcaption className="font-display text-lg font-semibold uppercase tracking-[0.06em] text-titanium" data-id="element-546" data-mp="2lcs9gwghf8xn">Removable setup</figcaption>
          <svg viewBox="0 0 300 120" className="mt-3 w-full" role="img" aria-label="Light positions drifting after each recharge" data-id="element-547" data-mp="2gd5vgkstxons">
            <rect x="10" y="20" width="280" height="80" rx="12" fill="#0B1A2A" stroke="#B8C6D3" strokeOpacity="0.25" data-id="element-548" data-mp="2bgyp4qwiub5b" />
            {[[60, 46], [72, 58], [52, 66], [230, 44], [244, 62], [222, 70]].map(([x, y], i) => <circle key={i} cx={x} cy={y} r="9" fill="none" stroke="#B8C6D3" strokeOpacity={0.25 + i % 3 * 0.2} strokeDasharray="3 3" data-id="element-549" data-mp="3j9g8zei9kz9v" data-mpi={i} />)}
            <text x="150" y="64" textAnchor="middle" fill="#B8C6D3" fontSize="11" fontFamily="Inter" data-id="element-550" data-mp="3o9b3ds1906zo">position shifts</text>
          </svg>
        </figure>
        <figure className="mf-hud border border-marine/60 bg-[#0D2440] p-5" data-id="element-551" data-mp="3ea3nax34py8v">
          <figcaption className="font-display text-lg font-semibold uppercase tracking-[0.06em] text-white" data-id="element-552" data-mp="3ec6n28u335qs">
            Magnetic Mount System
          </figcaption>
          <svg viewBox="0 0 300 120" className="mt-3 w-full" role="img" aria-label="Lights returning to the same fixed bases" data-id="element-553" data-mp="asbslaxlz06z">
            <rect x="10" y="20" width="280" height="80" rx="12" fill="#0B2A4A" stroke="#9CD8FF" strokeOpacity="0.5" data-id="element-554" data-mp="3s81xdqaf38ik" />
            {[60, 240].map(x => <g key={x} data-id="element-555" data-mp="osd0vbg7d9wh">
                <circle cx={x} cy="58" r="13" fill="#E7ECF1" data-id="element-556" data-mp="os39bjfieuoo" />
                <circle cx={x} cy="58" r="9" fill="#F4F7FA" stroke="#248DFF" strokeWidth="2.5" data-id="element-557" data-mp="tke82iyikafn" />
              </g>)}
            <text x="150" y="64" textAnchor="middle" fill="#9CD8FF" fontSize="11" fontFamily="Inter" data-id="element-558" data-mp="13fl8k2aayx3p">same position, every time</text>
          </svg>
        </figure>
      </div>

      <table className="mt-8 w-full text-left text-sm md:text-base" data-id="element-559" data-mp="uedl6f9brgoe">
        <caption className="sr-only" data-id="element-560" data-mp="pglshj0uvqj5">Removable setup compared with the Magnetic Mount System</caption>
        <thead data-id="element-561" data-mp="kgz72mavj3z9">
          <tr className="border-b mf-hairline text-xs uppercase tracking-[0.12em] text-titanium" data-id="element-562" data-mp="khim9v953e9l">
            <th scope="col" className="w-1/4 py-3 pr-3 font-medium" data-id="element-563" data-mp="fqabovw2pmuu" />
            <th scope="col" className="py-3 pr-3 font-medium" data-id="element-564" data-mp="arfn1dbfd42t">Removable setup</th>
            <th scope="col" className="py-3 font-semibold text-ice" data-id="element-565" data-mp="apctijb2cstc">Magnetic Mount System</th>
          </tr>
        </thead>
        <tbody data-id="element-566" data-mp="1qhrzkiys6wd">
          {mountComparison.map(row => <tr key={row.label} className="border-b mf-hairline align-top" data-id="element-567" data-mp="1pzkfrquq695">
              <th scope="row" className="py-4 pr-3 font-display text-base font-semibold uppercase tracking-[0.04em] text-white" data-id="element-568" data-mp="3sydgkmbvfqc2">
                {row.label}
              </th>
              <td className="py-4 pr-3 text-titanium" data-id="element-569" data-mp="2ddbhx0yzyges">
                <span className="flex gap-2" data-id="element-570" data-mp="2dg7f2n30t126">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-titanium/60" aria-hidden data-id="element-571" data-mp="2icxwbdqka2p6" />
                  {row.other}
                </span>
              </td>
              <td className="py-4 text-white" data-id="element-572" data-mp="2mcgcjw7ftplo">
                <span className="flex gap-2" data-id="element-573" data-mp="1ppl7ewwxhisp">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-marine" aria-hidden data-id="element-574" data-mp="1pmpanbwth05u" />
                  {row.ours}
                </span>
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}